import { makeSx } from '../../theme/_utils'

export default makeSx({
    UserFormContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        width: '100%',
    },
    UserForm: {
        width: '100%',
        height: '100%',
        background: '#ffffff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
        padding: {
            xs: '1.5rem',
            md: '3.5rem',
        },
    },
    formGroup: {
        width: '100%',
    },
    formGroupInner: {
        width: '100%',
    },
})
